module.exports = __webpack_public_path__ + "static/media/profile_text.73042e33.png";